import { CheckOutlined as CheckOutlined_kojaro } from './CheckOutlined.kojaro';
import { CheckOutlined as CheckOutlined_zoomg } from './CheckOutlined.zoomg';
import { CheckOutlined as CheckOutlined_zoomit } from './CheckOutlined.zoomit';
import { CheckOutlined as CheckOutlined_phosphor } from './CheckOutlined.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return CheckOutlined_kojaro;

    case 'zoomg':
      return CheckOutlined_zoomg;


    case 'phosphor':
      return CheckOutlined_phosphor;

    default:
      return CheckOutlined_zoomit;
  }
};

export const CheckOutlined = IconRenderer();
